var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGem(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 30,
    viewBox: "0 0 29 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.2465 1.06499L14 0.925302L13.7535 1.06499L2.50349 7.43999L2.22527 7.59765L2.25171 7.91635L3.43421 22.1663L3.45549 22.4228L3.67652 22.5545L13.7441 28.5545L14 28.7071L14.256 28.5545L24.3235 22.5545L24.5446 22.4228L24.5658 22.1663L25.7483 7.91635L25.7747 7.59765L25.4965 7.43999L14.2465 1.06499Z",
    fill: "#6E6F72",
    stroke: "#6E6F72"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14 1.5L2.75 7.875L7.30921 10.125L14 6.375V1.5Z",
    fill: "#FAD9F8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.75 7.875L3.875 22.125L8 19.5L7.30921 10.125L2.75 7.875Z",
    fill: "#F49DF4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25.25 7.875L14 1.5V6.375L20.6908 10.125L25.25 7.875Z",
    fill: "#F49DF4"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M24.125 22.125L25.25 7.875L20.6908 10.125L20 19.5L24.125 22.125Z",
    fill: "#D35BFA"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M14 28.125L24.125 22.125L20 19.5L14 22.875V28.125Z",
    fill: "#A02CDD"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M3.875 22.125L14 28.125V22.875L8 19.5L3.875 22.125Z",
    fill: "#BB55F1"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M14 6.375L7.30921 10.125L8 19.5L14 22.875L20 19.5L20.6908 10.125L14 6.375Z",
    fill: "#E79CF7"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    }
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.2494 7.88281L24.125 22.1247L14 28.1247L7.50049 24.2731C11.4802 17.073 17.7137 11.2923 25.2494 7.88281Z",
    fill: "#6E6F72"
  }))), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.875 10.125L2.75 7.875L7.0625 9.75L13.8125 6L14 1.5L14.1875 6L20.9375 9.75L25.25 7.875L21.3125 10.125L20.7496 19.5325L24.125 22.125L20.347 20.1653L14.375 23.4375L14 28.125L13.625 23.4375L7.65299 20.1653L3.875 22.125L7.4375 19.5L6.875 10.125ZM8 19.5L14 22.875L20 19.5L20.5625 10.125L14 6.375L7.4375 10.125L8 19.5Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGem);
export default __webpack_public_path__ + "static/media/Gem.33c3bbb55aa3106c6b8c0151175cb16e.svg";
export { ForwardRef as ReactComponent };